import React, { Component, Fragment } from 'react';
import Input from 'Components/Input';
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import Cx from 'classnames';
import { isAdaniWilmar } from 'Utils';


export default class AddOtherCosts extends Component {

    render() {
        const { trip, onChange, deleteSlab, addSlab, addHC, deleteHC, onChangeHC, tableDetails, secondaryContractType} = this.props;
        return (
            <Fragment>
            <div className={'ml-10 flex'}>
                
                <div className={Cx('inBlock', {
                    'col-2': tableDetails && !isAdaniWilmar(),
                    'col-3': !tableDetails && !isAdaniWilmar(),
                    'wt-60p': isAdaniWilmar() && secondaryContractType === 2
                })}>
                {(trip.slabs || []).map((slab, slabInd) => {
                    return(
                    <Fragment>
                    {slabInd === 0 && <div className="flex flex-middle mb-20" key={`{slbHeader_${slabInd}}`}>
                        <div className="fBold fs-14 header-dark-color wt-200 pl-5 tCenter">Description</div>
                        <div className="fBold fs-14 header-dark-color wt-150 pl-10 tCenter">{`${isAdaniWilmar() ? 'Per MT' : 'KM'} Range`}</div>
                        {isAdaniWilmar() && secondaryContractType === 2 && <>
                            <div className="fBold fs-14 header-dark-color wt-100 pl-10 tCenter">LPP</div>
                            <div className="fBold fs-14 header-dark-color wt-100 pl-10 tCenter">MR</div>
                        </>}
                        <div className="fBold fs-14 header-dark-color wt-100 pl-10 tCenter">QBR</div>
                        {isAdaniWilmar() && secondaryContractType === 2 && <>
                            <div className="fBold fs-14 header-dark-color wt-150 pl-10 tCenter">Business Volume(MT)</div>
                        </>}
                        {!tableDetails && <div className="fBold fs-14 header-dark-color wt-100 pl-10 tCenter"></div>}
                    </div>}
                    <div className="flex flex-middle mb-10" key={`{slb_${slabInd}}`}>
                        <div className={Cx("fs-14 header-dark-color wt-200 pl-5", {
                            'tCenter': tableDetails
                        })}>
                            {!tableDetails ? <Input
                                value={slab.costChargeDesc} 
                                name="costChargeDesc"
                                placeholder="Description"
                                onChange={onChange.bind(this, slabInd)}
                            /> : slab.costChargeDesc
                        }
                        </div>
                        <div className={Cx("fs-14 header-dark-color wt-150 pl-10", {
                            'tCenter': tableDetails,
                            'flex': !tableDetails
                        })}>
                        {!tableDetails ? 
                            <Fragment>
                            <Input 
                                className={'wt-70 inBlock'}
                                type="number"
                                value={slab.fromKm} 
                                name="fromKm"
                                placeholder="From"
                                onChange={onChange.bind(this, slabInd)}
                            />
                            <div className={'mt-10 inBlock'}>{'-'}</div>
                           <Input 
                                className={'wt-70 inBlock'}
                                type="number"
                                value={slab.toKm>0?slab.toKm:""} 
                                name="toKm"
                                placeholder="To"
                                onChange={onChange.bind(this, slabInd)}
                                
                            />
                            </Fragment> : 
                                `${slab.fromKm} ${slab.toKm>0? "-":""} ${slab.toKm>0? slab.toKm: ""}`}
                        </div>
                        {isAdaniWilmar() && secondaryContractType === 2 && <>
                            <div className={Cx("fs-14 header-dark-color wt-100 pl-10", {
                                'tCenter': tableDetails
                             })}>
                                {!tableDetails ? <Input 
                                    type="number"
                                    className={'wt-70'}
                                    value={slab.lpp} 
                                    name="lpp"
                                    placeholder="LPP"
                                    onChange={onChange.bind(this, slabInd)}
                                    readOnly={true}
                                /> : slab.qbr>0 ? slab.lpp:" "}
                            </div>
                            <div className={Cx("fs-14 header-dark-color wt-100 pl-10", {
                                'tCenter': tableDetails
                             })}>
                                {!tableDetails ? <Input 
                                    type="number"
                                    className={'wt-70'}
                                    value={slab.marketRate || ""} 
                                    name="marketRate"
                                    placeholder="MR"
                                    onChange={onChange.bind(this, slabInd)}
                                /> : slab.qbr>0 ? slab.marketRate:" "}
                            </div>
                        </>}
                        <div className={Cx("fs-14 header-dark-color wt-100 pl-10", {
                            'tCenter': tableDetails
                        })}>
                            {!tableDetails ? <Input 
                                type="number"
                                className={'wt-70'}
                                value={slab.qbr>0?slab.qbr:""} 
                                name="qbr"
                                placeholder="QBR"
                                onChange={onChange.bind(this, slabInd)}
                            /> : slab.qbr>0 ? slab.qbr:" "}
                        </div>
                        {isAdaniWilmar() && secondaryContractType === 2 && 
                            <div className={Cx("fs-14 header-dark-color wt-150 pl-10", {
                                'tCenter': tableDetails
                             })}>
                                {!tableDetails ? <Input 
                                    type="number"
                                    className={'wt-100'}
                                    value={slab.businessVolume || ""} 
                                    name="businessVolume"
                                    placeholder="Business Volume"
                                    onChange={onChange.bind(this, slabInd)}
                                /> : slab.qbr>0 ? slab.businessVolume:" "}
                            </div>
                        }
                        {!tableDetails && <div className={'wt-100 pl-10'}>
                            <DeleteIcon 
                                className="wt-20 ht-20 tRight curP"
                                onClick={() => deleteSlab(slabInd)}
                            />
                        </div>}
                    </div>
                    { slab.toKm>0 && trip.secKmRun &&Number(slab.toKm)>=Number(trip.secKmRun) && <span className="danger-color fs-14 fBold">Please Enter Below To Range!</span>}
                    </Fragment>
                    )})}
                    {(trip.multiModeHeadingCharges || []).map((headingCharge, hCInd) => {
                    return(
                        <Fragment>
                        {(isAdaniWilmar() && hCInd === 0) && 
                        <div className="flex flex-middle mb-20" key={`{hcHeader_${hCInd}}`}>
                            <div className="fBold fs-14 header-dark-color wt-200 pl-5 tCenter">Description</div>
                            <div className="fBold fs-14 header-dark-color wt-100 pl-10 tCenter">QBR</div>
                            <div className="fBold fs-14 header-dark-color wt-100 pl-10 tCenter"></div>
                        </div>}
                        <div className="flex flex-middle mb-10"  key={`hc_${hCInd}`}>
                            <div className={Cx("fs-14 header-dark-color wt-200 pl-5", {
                                'tCenter': tableDetails
                            })}>
                                {!tableDetails ? <Input
                                    value={headingCharge.headingChargesValue} 
                                    name="headingChargesValue"
                                    placeholder="Description"
                                    onChange={onChangeHC.bind(this, hCInd)}
                                /> : headingCharge.headingChargesValue }
                            </div>
                            {!isAdaniWilmar() && <div className={Cx("fs-14 header-dark-color wt-150 pl-10", {
                                'tCenter': tableDetails
                            })}>
                                    {''}
                            </div>}
                            <div className={Cx("fs-14 header-dark-color wt-100 pl-10", {
                                'tCenter': tableDetails
                            })}>
                                {!tableDetails ? <Input 
                                    className={'wt-70'}
                                    type="number"
                                    value={headingCharge.headingChargesBudget} 
                                    name="headingChargesBudget"
                                    placeholder="QBR"
                                    onChange={onChangeHC.bind(this, hCInd)}
                                /> : headingCharge.headingChargesBudget }
                            </div>
                            {!tableDetails && <div className={'wt-100 pl-10'}>
                                <DeleteIcon 
                                    className="wt-20 ht-20 tRight curP"
                                    onClick={() => deleteHC(hCInd)}
                                />
                            </div>}
                        </div>
                    </Fragment>)})}
                </div>
                <div className={Cx('col-2 inBlock', {'col-3': isAdaniWilmar() })}>
                    {!tableDetails && (isAdaniWilmar() ? secondaryContractType === 2 : true) && <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 inBlock mt-20" onClick={addSlab}>+ Slab</button>}  
                    {!tableDetails && (isAdaniWilmar() ? secondaryContractType !== 2 : true) && <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 ml-20 inBlock" onClick={addHC}>+ {isAdaniWilmar() ? 'Additional' : 'Heading'} Cost</button>}
                </div>
                {/* <div className={'col-3 tCenter mt-30'}>
                    <button className="b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30" onClick={addSlab}>Add Slab</button>
                    <button className="b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20" onClick={addSlab}>Add Heading Cost</button>
                </div> */}
            </div>
            </Fragment>
        )
    }
}

